import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AppTokenHandler } from '../CommonService/app-token-handler';
import { Location } from '@angular/common';
// import { environment } from '../../environments/environment';
import { DataService } from './data.service';
//import { ConfigService } from './ConfigService';
import { environment } from 'src/environments/environment';
@Injectable()
export class AuthGuardService   {

  isRole = false;
  userDetails: any;
  roleList!: string[];
  href!: string;

  constructor(private router: Router, private appToken: AppTokenHandler,
    // private dddd: MatDialog,  private _global: Global,
    // private config: ConfigService,
    private location: Location,
    private _common: DataService) {
    // this.router.events.forEach((event) => {
    //     if (event instanceof NavigationEnd) {
    //         this.LogPageAnalytics();
    //     }
    // });
  }
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const expectedRole = next.data['expectedRole'];
    if (this.checkValueIsNullOrEmptyOrUndefined(this.appToken.getLoginUserInfo())) {
      this.href = this.location.path();
      this._common.GetUserDetails(this.href, expectedRole);
      return true;
    } else {
      this.userDetails = this.appToken.getLoginUserInfo();
      if (this.userDetails === null) {
        this.isRole = false;
      } else {
        this.isRole = false;
        this.roleList = this.userDetails.Roles.split(',');
        expectedRole.forEach((element: string) => {
          if (this.roleList.indexOf(element) >= 0) {
            this.isRole = true;
          }
        });
      }
      if (!this.isRole) {
        this.router.navigate(['/error/4']);
        return false;
      } else {

        return true;
      }
    }
  }
  checkValueIsNullOrEmptyOrUndefined(value: any) {
    if (value == null || value == undefined || value == "") {
      return true;
    }
    else {
      return false;
    }
  }

  LogPageAnalytics() {
    this._common
      .LogPageAnalytics(environment.pageAnalyticsUrl + '?PageTitle=' + window.location.href.replace('#/', '') + '&ApplicationCode=PayRecov')
      .subscribe(() => {

      }, () => {

      });
  }
}